module.exports = __webpack_public_path__ + "static/media/circle@2x.487fdb42.png";